/**
 * 日期时间工具函数
 * 统一使用北京时间(Asia/Shanghai UTC+8)显示
 */

/**
 * 将UTC时间转换为北京时间字符串
 * @param date ISO格式的日期字符串或Date对象
 * @returns 格式化后的北京时间字符串 (例如: 2025/12/6 04:49:23)
 */
export const formatBeijingTime = (date: string | Date | null | undefined): string => {
  if (!date) return '-';

  try {
    let d: Date;

    if (typeof date === 'string') {
      // 如果是ISO格式字符串但没有时区后缀，强制添加Z后缀（视为UTC时间）
      if (date.includes('T') && !date.includes('Z') && !date.includes('+') && !date.includes('-', 10)) {
        d = new Date(date + 'Z');
      } else if (!date.includes('T') && !date.includes('Z') && !date.includes('+')) {
        // 格式如 "2026-01-23 02:51:29"，替换空格为T并添加Z
        d = new Date(date.replace(' ', 'T') + 'Z');
      } else {
        d = new Date(date);
      }
    } else {
      d = date;
    }

    // 检查日期是否有效
    if (isNaN(d.getTime())) {
      console.error('无效的日期:', date);
      return '-';
    }

    // 手动计算UTC+8(北京时间)
    // 获取UTC时间戳并加8小时
    const utcTime = d.getTime();
    const beijingTime = new Date(utcTime + 8 * 60 * 60 * 1000);

    const year = beijingTime.getUTCFullYear();
    const month = String(beijingTime.getUTCMonth() + 1).padStart(2, '0');
    const day = String(beijingTime.getUTCDate()).padStart(2, '0');
    const hour = String(beijingTime.getUTCHours()).padStart(2, '0');
    const minute = String(beijingTime.getUTCMinutes()).padStart(2, '0');
    const second = String(beijingTime.getUTCSeconds()).padStart(2, '0');

    return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
  } catch (error) {
    console.error('日期格式化错误:', error);
    return '-';
  }
};

/**
 * 将UTC时间转换为北京日期字符串(不含时间)
 * @param date ISO格式的日期字符串或Date对象
 * @returns 格式化后的北京日期字符串 (例如: 2025/12/6)
 */
export const formatBeijingDate = (date: string | Date | null | undefined): string => {
  if (!date) return '-';

  try {
    let d: Date;

    if (typeof date === 'string') {
      // 如果是ISO格式字符串但没有时区后缀，强制添加Z后缀（视为UTC时间）
      if (date.includes('T') && !date.includes('Z') && !date.includes('+') && !date.includes('-', 10)) {
        d = new Date(date + 'Z');
      } else if (!date.includes('T') && !date.includes('Z') && !date.includes('+')) {
        // 格式如 "2026-01-23 02:51:29"，替换空格为T并添加Z
        d = new Date(date.replace(' ', 'T') + 'Z');
      } else {
        d = new Date(date);
      }
    } else {
      d = date;
    }

    // 检查日期是否有效
    if (isNaN(d.getTime())) {
      console.error('无效的日期:', date);
      return '-';
    }

    // 手动计算UTC+8(北京时间)
    const utcTime = d.getTime();
    const beijingTime = new Date(utcTime + 8 * 60 * 60 * 1000);

    const year = beijingTime.getUTCFullYear();
    const month = String(beijingTime.getUTCMonth() + 1).padStart(2, '0');
    const day = String(beijingTime.getUTCDate()).padStart(2, '0');

    return `${year}/${month}/${day}`;
  } catch (error) {
    console.error('日期格式化错误:', error);
    return '-';
  }
};
